import type { ComponentStatus, IncidentSeverity, IncidentStatus } from './api/statusApi';

export interface StatusMeta {
  label: string;
  color: string;
  bg: string;
}

/** Semantic (non-brand) colors for at-a-glance legibility — CONTRACTS.md §9. */
export const STATUS_META: Record<ComponentStatus, StatusMeta> = {
  operational: { label: 'Operational', color: 'var(--status-operational)', bg: 'var(--status-operational-bg)' },
  degraded_performance: {
    label: 'Degraded Performance',
    color: 'var(--status-degraded)',
    bg: 'var(--status-degraded-bg)',
  },
  partial_outage: { label: 'Partial Outage', color: 'var(--status-partial)', bg: 'var(--status-partial-bg)' },
  major_outage: { label: 'Major Outage', color: 'var(--status-major)', bg: 'var(--status-major-bg)' },
  under_maintenance: {
    label: 'Under Maintenance',
    color: 'var(--status-maintenance)',
    bg: 'var(--status-maintenance-bg)',
  },
};

/** For a component whose index.json entry has `monitored: false`. */
export const UNMONITORED_META: StatusMeta = {
  label: 'Not monitored',
  color: 'var(--status-unmonitored)',
  bg: 'var(--status-unmonitored-bg)',
};

export const SEVERITY_LABEL: Record<IncidentSeverity, string> = {
  sev1: 'Critical',
  sev2: 'Major',
  sev3: 'Minor',
};

export const INCIDENT_STATUS_LABEL: Record<IncidentStatus, string> = {
  investigating: 'Investigating',
  identified: 'Identified',
  monitoring: 'Monitoring',
  resolved: 'Resolved',
};

export function formatDateTime(iso: string): string {
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function formatRelative(date: Date): string {
  const seconds = Math.round((Date.now() - date.getTime()) / 1000);
  if (seconds < 10) return 'just now';
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  return `${hours}h ago`;
}
